// Guide §9.4 — device codes (A..Z, AA, AB ...) and invoice / return numbers.

/** 0 → A, 25 → Z, 26 → AA, 27 → AB ... (bijective base-26) */
export function deviceCodeFromIndex(i: number): string {
  if (!Number.isInteger(i) || i < 0) throw new RangeError('index must be a non-negative integer');
  let n = i + 1;
  let s = '';
  while (n > 0) {
    const r = (n - 1) % 26;
    s = String.fromCharCode(65 + r) + s;
    n = Math.floor((n - 1) / 26);
  }
  return s;
}

export function deviceIndexFromCode(code: string): number {
  if (!/^[A-Z]{1,4}$/.test(code)) throw new RangeError('bad device code');
  let n = 0;
  for (const ch of code) n = n * 26 + (ch.charCodeAt(0) - 64);
  return n - 1;
}

export const isDeviceCode = (s: string): boolean => /^[A-Z]{1,4}$/.test(s);

const pad = (n: number, w = 6) => String(n).padStart(w, '0');

export const formatInvoiceNo = (deviceCode: string, seq: number): string => `${deviceCode}-${pad(seq)}`;
export const formatReturnNo = (deviceCode: string, seq: number): string => `R-${deviceCode}-${pad(seq)}`;

const INVOICE_RE = /^([A-Z]{1,4})-(\d{6,})$/;
export function parseInvoiceNo(no: string): { deviceCode: string; seq: number } | null {
  const m = INVOICE_RE.exec(no);
  return m ? { deviceCode: m[1]!, seq: Number(m[2]) } : null;
}

export const INVOICE_LINK_MONTHS = 12; // Guide §11.7
export function invoiceLinkExpiry(saleDate: Date): Date {
  const d = new Date(saleDate);
  d.setUTCMonth(d.getUTCMonth() + INVOICE_LINK_MONTHS);
  return d;
}
